import React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { formatUserFactorModel } from '../utils/factorDataOptions';

// Saving another factor vendor asks first, because the switch re-checks the
// published Watchlist. Switch approves that re-check; Keep leaves the vendor
// as it is and saves the other settings; closing returns to Settings.
export default function FactorVendorSwitchConfirmDialog({ question, onAnswer }) {
    // Unmounted once answered, so its text never changes while it closes.
    if (!question) return null;
    const target = formatUserFactorModel(question.target);
    const current = formatUserFactorModel(question.current);
    return (
        <Dialog
            open
            onClose={() => onAnswer(null)}
            aria-labelledby="factor-vendor-switch-title"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="factor-vendor-switch-title">{`Switch to ${target}?`}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {`Your Watchlist will be re-checked against ${target} data and switches `
                        + 'when the check completes. If any securities change, you review '
                        + `them first. Securities without verified ${target} data are excluded.`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onAnswer(false)}>{`Keep ${current}`}</Button>
                <Button variant="contained" onClick={() => onAnswer(true)}>
                    {`Switch to ${target}`}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

FactorVendorSwitchConfirmDialog.propTypes = {
    question: PropTypes.shape({
        target: PropTypes.string,
        current: PropTypes.string,
    }),
    onAnswer: PropTypes.func.isRequired,
};
